import { Injectable } from '@angular/core';
import { ConstantService } from "../../../core/services/constant.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, map} from 'rxjs/operators';
import {CryptoJsService} from "../../../core/services/crypto-js.service";

@Injectable({
  providedIn: 'root'
})
export class PlanService {
  private pageSize = 300;

  private planUrl = ConstantService.PLAN_URL

  private coveragePlanUrl = ConstantService.COVERAGE_PLAN_URL
  private projectId = this.localStorage.getItem("projectId");

  constructor(private http: HttpClient, private readonly localStorage: CryptoJsService) { }

  getListPlan(): Observable<any> {
    return this.http.get<{}>(`${this.planUrl}?is_enable=true&is_active=true&pageSize=${this.pageSize}`).pipe(
      map((data) => {
        return data;
      })
    );
  }
   getPlanById(id:string): Observable<any> {
    return this.http.get<{}>(`${this.planUrl}${id}`).pipe(
        map((data) => {
          return data;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => new Error(error.message));
        })
    );
  }

  getListPlanDetails(): Observable<any> {
   
    let data={'projectID':this.localStorage.getItem("projectId")}
    ////console.log('data',data);
    return this.http.post<{}>(this.planUrl+'details/'+this.localStorage.getItem("projectId"),data).pipe(
      map((data) => {
        return data;
      })
    );
  }

  postPlanMenbershipCustomer(data): Observable<any> {
    return this.http.post<{}>(this.planUrl+'customer/', data).pipe(
        map((data) => {
          return data;
        }),
        catchError((error: HttpErrorResponse) => {
          console.log('error', error);
          return throwError(() => new Error(error.message));
        })
    );
  }

  postCustomerProductSelection(data: {
    executiveID: string;
    dni: string;
    channel: string;
    project_id: string;
    product_id: string;
    membership_id?: string | null;
  }): Observable<any> {
    return this.http.post<any>(`${this.planUrl}customer/product-selection/`, data);
  }

  getMenbershipCustomer(data): Observable<any> {
    return this.http.get<{}>(`${this.planUrl}?is_active=true&dni=${data}`).pipe(
        map((data) => {
          return data;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => new Error(error.message));
        })
    );
  }


  getCustomerDocuments(data): Observable<any> {
    return this.http.get<{}>(`${this.planUrl}customer/?dni=${data.dni}&is_active=true`).pipe(
        map((data) => {
          return data;
        })
    );
  }

  postPlanMenbership(): Observable<any> {
    return this.http.get<{}>(`${this.planUrl}?project_id=${this.projectId}`).pipe(
        map((data) => {
          return data;
        })
    );
  }

  getListPlanByPolicID( policyID): Observable<any> {
    return this.http.get<{}>(`${this.planUrl}?is_enable=true&is_active=true&policy_id=${policyID}`).pipe(
        map((data) => {
            return data;
        })
    );
  }

  postPlan(data: {}): Observable<any> {
    return this.http.post<any>(this.planUrl, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  patchPlan( data: {},id: string): Observable<any> {
    const url = `${this.planUrl}${id}`;
    return this.http.patch<{}>(url, data).pipe(
      map((data) => {
        return data;
      })
    );
  }

  deletePlan(id: String): Observable<any> {
    const url = `${this.planUrl}${id}`;
    return this.http.delete<{}>(url).pipe(
      map((data) => {
        return data;
      })
    );
  }

  //COVERAGE
  postCoveragePlan(data: {}): Observable<any> {
    return this.http.post<any>(this.coveragePlanUrl, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  patchCoveragePlan( data: {},id: string): Observable<any> {
    const url = `${this.coveragePlanUrl}${id}`;
    return this.http.patch<{}>(url, data).pipe(
      map((data) => {
        return data;
      })
    );
  }

  deleteCoveragePlan(id: String): Observable<any> {
    const url = `${this.coveragePlanUrl}${id}`;
    return this.http.delete<{}>(url).pipe(
      map((data) => {
        return data;
      })
    );
  }


}
